module.exports = __webpack_public_path__ + "img/T934.49ae3b31.jpg";